import { wsurl } from './CommonFunctions';
import { DeleteToService, GetFromService, PostToService, PutToService } from './services/ServiceHub';
import { Warehouse, Person, Tool, Users, ToolHistory, Classes } from './types';
import { UserRole } from './types';


const API_URL = process.env.REACT_APP_API_URL || wsurl;

/*export const WAREHOUSES: Warehouse[] = [
  { id: 22, name: 'Magazzino Villa', location:'via pippo' },
  { id: 44, name: 'Box Villa', location:'via pluto' },
  { id: 45, name: 'Deposito Centrale', location:'via paperino' },
  { id: 66, name: 'Oreto', location:'via minnie' },
];*/

export const RESTPEOPLE = async (): Promise<Person[]> => {
  const response = await GetFromService(API_URL+'/people');
  return response.json();
} 
export const RESTASSIGNMENTLOG = async (token:string): Promise<any> => {
  const response = await GetFromService(API_URL+'/assignmentLogs',token);
  return response.json();
}


export const RESTME = async (token:string): Promise<Users> => {
  const response = await GetFromService(API_URL+'/me',token);
  return response.json();
}

export const RESTTOOLPERUSERID = async (token:string): Promise<any> => {
  const response = await GetFromService(API_URL+'/tools/forusrid',token);
  return response.json();
}
export const RESTHISTORYPERUSERID = async (token:string): Promise<ToolHistory[]|null> => {
  const response = await GetFromService(API_URL+'/history/forusrid',token);
  return response.json();
}
export const RESTHISTORY = async (token:string): Promise<any> => {
  const response = await GetFromService(API_URL+'/history',token);
  return response.json();
}
export const RESTRELEASEHISTORY = async (hist:ToolHistory,token:string): Promise<any> => {
  const response = await PostToService(API_URL+'/history/release',JSON.stringify(hist),token);
  return response.json();
}
export const RESTPOSTHISTORY = async (hist:ToolHistory,token:string): Promise<any> => {
  const response = await PostToService(API_URL+'/history',JSON.stringify(hist),token);
  return response.json();
}
export const RESTPUTHISTORY = async (hist:ToolHistory,token:string): Promise<any> => {
  const response = await PutToService(API_URL+'/history/'+hist.id!,token);
  return response.json();
}
export const RESTDELETEHISTORY = async (hist:ToolHistory,token:string): Promise<any> => {
  const response = await DeleteToService(API_URL+'/history/'+hist.id!,token);
}

export const RESTWAREHOUSES = async (token:string): Promise<Warehouse[]> => {
  const response = await GetFromService(API_URL+'/warehouses',token);
  return response.json();
}
export const RESTPOSTWAREHOUSE = async (warehouse:Warehouse, token:string): Promise<any> => {
  const response = await PostToService(API_URL+'/warehouses', JSON.stringify(warehouse), token);
  return response.json();
} 
export const RESTUPDATEWAREHOUSE = async (warehouse:Warehouse, token:string): Promise<any> => {
  const response = await PutToService(API_URL+'/warehouses/'+warehouse.id!, JSON.stringify(warehouse), token);
  return response.json();
}
export const RESTDELETEWAREHOUSE = async (warehouseid:number, token:string): Promise<any> => {
  const response = await DeleteToService(API_URL+'/warehouses/'+warehouseid, token);
  //return response.json();
}

export const RESTTOOL = async (token:string): Promise<Tool[]> => {
  const response = await GetFromService(API_URL+'/tools',token);
  return response.json();
} 

export const RESTPOSTTOOL = async ( tool:Tool, token:string): Promise<Tool> => {
  const response = await PostToService(API_URL+'/tools',JSON.stringify(tool),token);
  return response.json();
} 
export const RESTUPDATETOOL = async (tool:Tool, token:string): Promise<Tool> => {
  const response = await PutToService(API_URL+'/tools', JSON.stringify(tool), token);
  return response.json();
}
export const RESTDELETETOOL = async (token:string): Promise<Tool[]> => {
  const response = await PostToService(API_URL+'/tools',token);
  return response.json();
}

export const RESTUSER = async (token:string): Promise<any> => {
  const response = await GetFromService(API_URL+'/users',token);
  return response.json();
}
export const RESTPOSTUSER = async (user:Users, token:string): Promise<any> => {
  const response = await PostToService(API_URL+'/users', JSON.stringify(user), token);
  return response.json();
}
export const RESTUPDATEUSER = async (user:Users, token:string): Promise<any> => {
  const response = await PutToService(API_URL+'/users/'+user.id!, JSON.stringify(user), token);
  return response.json();
}
export const RESTDELETEUSER = async (userid:number, token:string): Promise<any> => {
  const response = await DeleteToService(API_URL+'/users/'+userid, token);
  //return response.json();
}

export const RESTCLASSES = async (token:string): Promise<Classes[]> => {
  const response = await GetFromService(API_URL+'/classes',token);
  return response.json();
}
export const RESTPOSTCLASSES = async (classes:Classes, token:string): Promise<any> => {
  const response = await PostToService(API_URL+'/classes', JSON.stringify(classes), token);
  return response.json();
}
export const RESTUPDATECLASSES = async (classes:Classes, token:string): Promise<any> => {
  const response = await PutToService(API_URL+'/classes/'+classes.id!, JSON.stringify(classes), token);
  return response.json();
}
export const RESTDELETECLASSES = async (classid:number, token:string): Promise<any> => {
  const response = await DeleteToService(API_URL+'/classes/'+classid, token);
  //return response.json();
}



/*export const PEOPLE: Person[] = [
  { id: 'p1', name: 'Andrea' , surname: 'Rossi'},
  { id: 'p2', name: 'Giuseppe', surname: 'Verdi' },
  { id: 'p3', name: 'Marco' ,surname: 'Bianchi' },
  { id: 'p4', name: 'Zamparrone (Destinazione)' ,surname:'Paparazzi' }, // Example destination that is also a person/entity
];*/

/*export const INITIAL_TOOLS: Tool[] = [
  { id: 21, name: 'Compressore Pro', description: 'Compressore ad aria 50L, alta pressione.', imageUrl: 'https://picsum.photos/seed/compressor/300/200', warehouseId: 'wh1', personId: null, currentAssignmentLogId: null },
  { id: 22, name: 'Kit Coltelli Precisione', description: 'Set di coltelli multiuso per tagli di precisione.', imageUrl: 'https://picsum.photos/seed/knives/300/200', warehouseId: 'wh1', personId: null, currentAssignmentLogId: null },
  { id: 23, name: 'Makita Trapano Avvitatore', description: 'Trapano avvitatore a batteria 18V, con 2 batterie.', imageUrl: 'https://picsum.photos/seed/makita_drill/300/200', warehouseId: 'wh2', personId: null, currentAssignmentLogId: null },
  { id: 42, name: 'Makita Sega Circolare', description: 'Sega circolare potente per tagli legno.', imageUrl: 'https://picsum.photos/seed/makita_saw/300/200', warehouseId: 'wh2', personId: null, currentAssignmentLogId: null },
  { id: 't5', name: 'Livella Laser Autolivellante', description: 'Livella laser con treppiede, portata 30m.', imageUrl: 'https://picsum.photos/seed/laserlevel/300/200', warehouseId: 'wh1', personId: null, currentAssignmentLogId: null },
  { id: 't6', name: 'Cassetta Attrezzi Completa', description: 'Valigia con 120 pezzi assortiti.', imageUrl: 'https://picsum.photos/seed/toolbox/300/200', warehouseId: 'wh3', personId: null, currentAssignmentLogId: null },
  { id: 't7', name: 'Martello Demolitore', description: 'Potente martello demolitore per lavori pesanti.', imageUrl: 'https://picsum.photos/seed/demolitionhammer/300/200', warehouseId: 'wh3', personId: null, currentAssignmentLogId: null },
  { id: 't8', name: 'Saldatrice Inverter', description: 'Saldatrice leggera e compatta, tecnologia inverter.', imageUrl: 'https://picsum.photos/seed/welder/300/200', warehouseId: 'wh2', personId: null, currentAssignmentLogId: null },
];*/

// Modello Gemini per l'analisi di immagini (multimodale)
export const GEMINI_MODEL_VISION = "gemini-2.5-flash-preview-04-17";

// Prompt di default in italiano
export const DEFAULT_DECRIPTION_ITALIAN = "Breve descrizione dell'articolo";

export const DEFAULT_NOTE_ITALIAN = "Note per l'attrezzatura, segni di usura, problemi elettrici, etc..";

export const DEFAULT_CODE_ITALIAN = "Codice a barre o RFID se in possesso di pistola.";



export const USER_ROLE_OPTIONS = [
  { value: UserRole.Administrator, label: "Amministratore" },
  { value: UserRole.User, label: "Fruitore" },
];

export const INITIAL_USER_FORM_DATA = {
  Name: '',
  Surname: '',
  passwordInput: '',
  Email: '',
  role: UserRole.User, // Default role
};

export const INITIAL_WAREHOUSE_FORM_DATA = {
  name: '',
  location: '',
};

export const INITIAL_CLASSES_FORM_DATA = {
  name: '',
};